 

export interface IResponse {
    success: boolean;
    result?: any;
    error?: any;
}

export interface ILead {
    Audit_IsActive: boolean;
    AccountContactName: string;
    LeadEntityID: number;
    LeadActionTypeCode: string;
    Address: string;
    Feasibility: string;
    records?: [];
    Latitude: number;
    Longitude: number;
    LeadAccountID: number;
    AccountLinkedEntityID: number;
    ContractTotalRecurringIncl: number;
    AddOns: Array<any>;
    LeadDescription: string;
    LeadNotes: string;
    StreetNumber?: string;
    StreetName?: string;
    PostalCode?: string;
    Region?: string;
    Town?: string;
    Suburb?: string;
    DeliveryAddressSameAsInstallationAddress: boolean;
    LeadContactNumber: string;
    AccountEmail: string;
    AccountContactNumber: string;
    AccountIDNumber: string;
    PaymentType: string;
    FullAddress: string;
    DeliveryTown: string;
    DebitOrderCollectionRunID: number;
    LeadStatus?: string;
}


export interface ITicketTopic {
    AccessControlTopicUserRoles: [];
    Id: Number;
    IsPublic: boolean,
    Name: string,
    RestrictAccess: boolean,
}

export enum EServiceAccountStatus {
    ConnectedBilling = 'Connected and Billing',
    Billing = 'Billing',
    Connected = 'Connected',
    Deactivated = 'Deactivated',
    Suspended = 'Suspended',
    ServiceUpgrade = 'Service Upgrade',
    ServiceDowngrade = 'Service Downgrade',
    ServiceCancellation = 'Service Cancellation'
}

export interface StatusDetail {
    label: string;
    color: string;
    textColor?: string;
}

export interface IBankList {
    BankName: string;
    DefaultCode: string;
    IsValidated: boolean;
    IsDefault: boolean;
}

export const EServiceAccountStatusDetails: { [key in EServiceAccountStatus]: StatusDetail } = {
    [EServiceAccountStatus.ConnectedBilling]: { label: 'Connected and Billing', color: 'bg-[#9edd46]', textColor: 'text-[#a6ce8b]' }, // Green
    [EServiceAccountStatus.Billing]: { label: 'Billing', color: 'bg-orange-100' }, // Orange
    [EServiceAccountStatus.Connected]: { label: 'Connected', color: 'bg-blue-100' }, // Blue
    [EServiceAccountStatus.Deactivated]: { label: 'Deactivated', color: 'bg-gray-100' }, // Gray
    [EServiceAccountStatus.Suspended]: { label: 'Suspended', color: 'bg-red-100' }, // Red
    [EServiceAccountStatus.ServiceUpgrade]: { label: 'Service Upgrade', color: 'bg-yellow-100' }, // Yellow
    [EServiceAccountStatus.ServiceDowngrade]: { label: 'Service Downgrade', color: 'bg-brown-100' }, // Brown
    [EServiceAccountStatus.ServiceCancellation]: { label: 'Service Cancellation', color: 'bg-darkred-100' } // Dark Red
};

export interface iDebitOrderMandate {
    Audit_CreatedDate: string;
    Audit_IsActive: boolean;
    Audit_IsDeleted: boolean;
    BillingEmail: string;
    DebitAmount: number;
    DebitOrderMandateFileURL: string;
    EntityAccountDebitOrderMandateID: number;
    EntityAccountID: number;
    IsAlternative: boolean;
    LeadEntityID: number;
    LeadNumber: string;
    OrganisationID: number;
    Status: string;
    SafeResourceUrl: any;
}


export type Package = {
    packageEntityID: number;
    packageName: string;
    totalRecurring: number;
    packageDescription: string;
    packageCategoryTypeCode: string;
    PackageSupplierOrganisationEntity: string;
    MbpsDownload: number,
    MbpsUpload: number,
    Tags: any,

};


export interface ITicketTopics {
    AccessControlTopicUserRoles: [],
    Id: number,
    IsPublic: boolean,
    Name: string,
    RestrictAccess: boolean
};

export interface ITicket {
    DateCreated: string,
    Status: string,
    Subject: string,
    TicketNumber: string,
    TicketID: number
};


export interface ICustomer 
    {
        PrimaryContactMobile: string;
        CustomerType: string;
        PrimaryContactName: string;
        PrimaryContactLastName: string;
        PrimaryContactEmail: string;
        FullName: string;
        FirstName: string;
        Username: string;
        Surname: string;
        IDNumber: string;
        MobileNumber: string;
        MobileUsername?: string;
        UserEntityID: string;
        EmailAddress: string;
        ProfileImageFileID?: string;
        AccountName: string;
        Reseller: any;
        IDType: string;
        EntityAccountEntityID?: number;
        CustomerAccount: {
            AccountName: string;
            AccountNumber: string;
            CustomerType: string;
            EntityAccountEntityID: number
        }
    }

    export interface ICustomerAccount {
        EntityAccountEntityID: number;
        AccountName: string,
        AccountNumber: string,
        Billing_IsActive: boolean,
        DebitOrderCollectionRunName: string,
        MobileAuthEnabled: boolean,
        Balance: any,
        CustomerType: string,
        IDNumber: string,
        PrimaryContactName: string,
        PrimaryContactLastName: string,
        PrimaryContactEmail: string,
        BillingEmail: string,
        PrimaryContactMobile: string,
        PaymentType: string,
        DebitOrderCollectionRunID: number,
        DimensionSettings: any[],
        UpdateMobileUsername: boolean,
        MarketingConsent: boolean,
        AddressPropertyType: string,
        CompetitionMarketingConsent: boolean,
        PromotionMarketingConsent: boolean
    }

    export interface IPendingPaymentDTO {
        pendingAmount: number,
        isPartialPayment: boolean,
        partialAmount: number | null;
        isForCardTokenisation: boolean;
        entityAccountID: number;
        leadEntityId: number;
        accountReceiptPaymentType?: string;
        isPendingPayment: boolean;
        debitOrderCollectionRunID: number;
    }

    export interface IPendingPayment {
        AccountName: string,
        AccountReceiptPaymentType: string,
        AmountReceived: number;
        EntityAccountID: number;
        EntityAccountReceiptID: number;
        IsPendingPayment: boolean;
        PendingAmount: number;
        PendingPaymentExternalIdentifier: string;
        PreventSyncToAccounting: boolean;
        Reversed: boolean;
    }


    export type IOrder = {
        AccountName: string,
        Address: string,
        AmountDue: number,
        DateCreated: string,
        DebitOrderMandateRequired: boolean,
        Feasibility: string,
        FutureCompletionSplitDates: boolean,
        HasPendingPromo: boolean,
        IsReactivation: boolean,
        Latitude: number,
        LeadAccountEntityID: number,
        LeadActionTypeCode: string,
        LeadDescription: string,
        LeadEntityID: number,
        LeadNumber: string,
        LeadStatus: string,
        Longitude: number,
        ProviderLogoFile: string,
        ReadyForFulfillment: boolean,
        debitOrderMandate?: iDebitOrderMandate;
        Items: Array<any>;
        isFibre?: boolean;
    }


export type Attachment = {
    EntityAttachmentName: string;
    EntityID: number;
    FileID: string;
    IsPrimaryAttachment: boolean;
    Notes: string;
}


export interface IEntityAttachment {
    EntityAttachmentID: number;
    EntityAttachmentOwnerEntityID: number;
    EntityAttachmentEntityID: number;
    FileID: number;
    EntityAttachmentName: string;
    Notes: string;
    IsPrimaryAttachment: boolean;
    CreatedDate: string;
    FileName: string;
    Audit_IsDeleted: boolean;
    Tags: any[];
    ReceiptCount: number;
    Authenticated: boolean;
    RSACitizen: boolean;
    MonthlySalary: number;
}
 
    interface IInvoice {
    TransactionStatus: string,
    TotalIncl: number,
    Status: string,
    DocumentNumber: string,
    DocumentDate: string
}
export interface IInvoices extends Array<IInvoice> { }
export interface IStatement {
    EntityAccountID: number,
    EntityAccountStatementHistoryID: number,
    FileName: string,
    FromDate: string
    SentDate: string,
    Status: string
    ToDate: string,
    Audit_CreatedDate: string,
}

export interface IStatementsArray extends Array<IStatement> { }


